<template>
  <div class="hqchart-right">
    <div class="five-grades">
      <div class="header flex-row">
        <div class="flex-row-item"><span class="label">委比</span><span class="value PriceUp">{{rowData.entrustRate}}</span></div>
        <div class="flex-row-item"><span class="label">委差</span><span class="value PriceUp">{{rowData.entrustDiff | priceFormat('entrustDiff')}}</span></div>
      </div>
      <div class="grades-list">
        <div class='item' v-for="(item,index) in offerGrp" :key="item.num||index">
          <span class="label">卖{{bidGrp.length-index}}</span>
          <span class="price" :class="item.color">{{item.sellPrice}}</span>
          <span class="count">{{item.sellAmount}}</span>
          <!-- <span class="opera" :class="item.color" @click.stop="fiveOpera('sell',item)">{{item.opera}}</span> -->
        </div>
      </div>
      <div class="grades-list">
        <div class='item' v-for="(item,index) in bidGrp" :key="item.num || index">
          <span class="label">买{{index+1}}</span>
          <span class="price" :class="item.color">{{item.buyPrice}}</span>
          <span class="count">{{item.buyAmount}}</span>
          <!-- <span class="opera" :class="item.color" @click.stop="fiveOpera('buy',item)">{{item.opera}}</span> -->
        </div>
      </div>
      
    </div>
    <div class="time-deal-box">
      <div v-show="showDetail" class="handicap">
        <div class="flex-row">
          <div class="flex-row-item" v-for="(item) in dealArr" :key="item.key">
            <span class="label">{{item.name}}</span>
            <span class="value" :class="dealStyle[item.key]?dealStyle[item.key].color:'amount'">{{rowData[item.key] | priceFormat(item.key)}}</span>
          </div>
        </div>
        <div class="flex-row">
          <div class="flex-row-item"><span class="label">外盘</span><span class="value amount">{{rowData.businessAmountOut | priceFormat('businessAmount')}}</span></div>
          <div class="flex-row-item"><span class="label">内盘</span><span class="value amount">{{rowData.businessAmountIn | priceFormat('businessAmount')}}</span></div>
          <div class="flex-row-item"><span class="label">涨停</span><span class="value PriceUp">{{rowData.upPx | priceFormat('upPx')}}</span></div>
          <div class="flex-row-item"><span class="label">跌停</span><span class="value PriceDown">{{rowData.downPx | priceFormat('downPx')}}</span></div>
        </div>
      </div>
      <div class="time-deal">
        <div class="detailstyle" style="">分时成交</div>
        <div class="btn-icon">
          <h-icon :name="!showDetail?'unfold':'packup'" style="cursor: pointer;" @on-click="showMore()">{{!showDetail?更多:隐藏}}</h-icon>
        </div>
      </div>
      <transition name="fade">
        <div>
          <slot></slot>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import unit from '@frame/utils/unit'
import { Chart } from 'hqchart'
export default {
  name: 'fiveGrades',
  props: {},
  data () {
    return {
      bidGrp: [],
      offerGrp: [],
      sharesPerHandNew: 1,
      rowData: {},
      prodCode: '',
      showDetail: true,
      dealStyle: {},
      dealArr: [
        {
          key: 'lastPx',
          name: '最新'
        },
        {
          key: 'preclosePx',
          name: '昨收'
        },
        {
          key: 'pxChange',
          name: '涨跌'
        }, {
          key: 'openPx',
          name: '开盘'
        }, {
          key: 'pxChangeRate',
          name: '涨幅'
        }, {
          key: 'highPx',
          name: '最高'
        }, {
          key: 'businessAmount',
          name: '总量'
        }, {
          key: 'lowPx',
          name: '最低'
        },
        // {
        //   key: 'currentAmount',
        //   name: '现量'
        // },
        // {
        //   key: 'volRatio',
        //   name: '量比'
        // },
        {
          key: 'businessBalance',
          name: '总额'
        },
        {
          key: 'avgPx',
          name: '均价'
        },
        // {
        //   key: 'turnoverRatio',
        //   name: '换手'
        // }
      ],
      operator: null,
      businessData: {}
    }
  },
  filters: {
    priceFormat (val, key) {
      return unit.priceFormat(val, key)
    }
  },
  created () {
    this.operator = Chart.IFrameSplitOperator
  },
  mounted () {
    this.$bus.$on('setDealStyle', (res = {}) => {
      this.dealStyle = res
    })
  },
  beforeDestroy () {
    // 解绑 eventBus事件
    this.busOff(['setDealStyle'])
  },
  methods: {
    // 设置数据
    initPageData (data) {
      let rowData = unit.cloneDeep(data)
      this.dealArr.forEach(item => {
        if (!rowData[item.key] || rowData[item.key] === '-') {
          rowData[item.key] = '-'
        } else {
          if (item.key === 'pxChangeRate') {
            rowData[item.key] = Number(rowData[item.key]).toFixed(2) + '%'
          }
          if (item.key === 'businessAmount' || item.key === 'currentAmount') {
            rowData[item.key] = rowData[item.key]/* / sharesPerHand */
          }
        }
      })
      rowData.entrustRate = rowData.entrustRate ? (rowData.entrustRate / 100) + '%' : '-'
      rowData.entrustDiff = rowData.entrustDiff ? rowData.entrustDiff : '-'
      rowData.businessAmountOut = rowData.businessAmountOut ? rowData.businessAmountOut/* / sharesPerHand */ : '-'
      rowData.businessAmountIn = rowData.businessAmountIn ? rowData.businessAmountIn/* / sharesPerHand */ : '-'
      this.rowData = rowData
    },
    fiveGradesDeal (msg) {
      if (this.prodCode) {
        const data = msg[this.prodCode]
        if (data) {
          this.gradesData = data
          this.gradesCount++
          console.log('five level data auto update start', data)
          this.initPageData(data)
          this.goodsFiveDeal(data.fiveLevel)
          this.updateDataStyle(data)
          // 获取累计成交数量
          let amt = this.businessData[this.prodCode] || 0
          if (data.businessAmount > amt) {
            // 更新累计成交数量为最新成交数量
            this.businessData[this.prodCode] = data.businessAmount
            // 通知K线图表更新
            this.send('klineRealRefresh', data)
          }
        }
      }
    },
    // 商品买卖五档
    goodsFiveDeal (data = {}) {
      const _this = this
      let bidGrp = [], offerGrp = []
      let grpBuy = data.bidGrp || []
      let grpSell = data.offerGrp || []
      // 一手对应的数量
      let sharesPerHand = data.sharesPerHand || this.sharesPerHandNew
      this.sharesPerHandNew = sharesPerHand
      // 商品代码
      this.prodCode = data.prodCode || this.prodCode
      grpSell = unit.cloneDeep(grpSell).reverse()
      let num = grpBuy.length || 5
      let time = new Date().getTime()
      for (let i = 0; i < num; i++) {
        let level = grpBuy[i] || {}
        let color = level.entrustPx ? _this.setClass(level.entrustPx) : ''
        let amount = level.totalEntrustAmount ? level.totalEntrustAmount / sharesPerHand : '-'
        bidGrp.push({
          buyPrice: level.entrustPx ? Number(level.entrustPx).toFixed(2) : '-',
          buyAmount: unit.priceFormat(amount, 'businessAmount'),
          num: time + i + '',
          color: color,
        })
      }
      for (let i = 0; i < num; i++) {
        let level = grpSell[i] || {}
        let color = level.entrustPx ? _this.setClass(level.entrustPx) : ''
        let amount = level.totalEntrustAmount ? level.totalEntrustAmount / sharesPerHand : '-'
        offerGrp.push({
          sellPrice: level.entrustPx ? Number(level.entrustPx).toFixed(2) : '-',
          sellAmount: unit.priceFormat(amount, 'businessAmount'),
          num: time + i + '',
          color: color,
        })
      }
      _this.bidGrp = unit.cloneDeep(bidGrp)
      _this.offerGrp = unit.cloneDeep(offerGrp)
    },
    setClass (price) {
      return this.getColor(price, this.rowData.preclosePx)
    },
    // 设置颜色
    updateDataStyle (data) {
      const { preclosePx } = data
      let color0 = this.getColor(data.openPx, preclosePx)
      let color1 = this.getColor(data.highPx, preclosePx)
      let color2 = this.getColor(data.lowPx, preclosePx)
      let color3 = this.getColor(data.lastPx, preclosePx)
      let color4 = this.getColor(data.avgPx, preclosePx)
      let colorInfo = {
        openPx: { color: color0 },
        highPx: { color: color1 },
        lowPx: { color: color2 },
        lastPx: { color: color3 },
        preclosePx: { color: 'preclosePx' },
        pxChange: { color: color3 },
        pxChangeRate: { color: color3 },
        avgPx: { color: color4 },
        businessAmount: { color: 'amount' },
        currentAmount: { color: 'amount' },
        businessBalance: { color: 'amount' }
      }
      this.dealStyle = colorInfo
    },
    send (key, value) {
      this.$bus.$emit(key, value)
    },
    busOff (keys) {
      if (!Array.isArray(keys)) {
        keys = [keys]
      }
      for (const key of keys) {
        this.$bus.$off(key)
      }
    },
    getColor (val, prl) {
      return this.operator.FormatValueColor(val, prl)
    },
    showMore () {
      this.showDetail = !this.showDetail
      this.send('showMoreTick', this.showDetail)
    }
  },
}
</script>
<style lang="scss" scoped>
$border_color: #444444;
$text_color: #00FDFE;
$text-size: 16px;
$optext-size: 15px;
.hqchart-right {
  height: calc(100% - 34px);
  color: #909399;
  font-size: 14px;
}
.five-grades {
  width: 100%;
  .header {
    border-top: 1px solid $border_color;
  }
  .grades-list {
    border-bottom: 1px solid $border_color;
    line-height: 19px;
    .item {
      padding: 0 4px 0 4px;
      display: flex;
      .label {
        width: 15%;
      }
      .price {
        width: 27%;
        text-align: right;
        font-size: $text-size;
      }
      .count {
        width: 33%;
        text-align: right;
        color: $text_color;
        font-size: $text-size;
      }
      .opera {
        width: 20%;
        text-align: right;
        font-size: $optext-size;
        cursor: pointer;
      }
    }
  }
}
.flex-row {
  display: flex;
  padding: 0 4px 0 0px;
  border-bottom: 1px solid $border_color;
  flex-wrap: wrap;
  .flex-row-item {
    width: 50%;
    line-height: 19px;
    display: flex;
    padding-left: 4px;
    .label {
      padding-right: 6px;
      flex: 1;
    }
    .value {
      flex: 3;
      text-align: right;
      font-size: $text-size;
    }
    // .PriceNull {
    //   color: red;
    // }
    .amount {
      color: $text_color;
    }
  }
}
.time-deal-box {
  height: calc(100% - 213px);
  .time-deal {
    background: #1E1F20;
    display: flex;
    padding: 0 10px;
    & > div {
      flex: 1.5;
      text-align: right;
    }
    .btn-icon {
      flex: 1;
      text-align: right;
    }
  }
  .flex-row {
    .flex-row-item {
      line-height: 18px;
    }
  }
}
.PriceNull {
  color: #909399;
}
.preclosePx {
  color: #DEDEDE;
}
</style>
